module.exports = __webpack_public_path__ + "static/media/MY-UPM.15771db2.png";